import UserSettingsService from "src/services/userSettingsService";

import { Provisioning } from "@dashboard/provisioning/types";

export function getDefaultProvisioning(provisionings: Provisioning[]): Provisioning | null {
    if (provisionings.length === 0) {
        return null;
    }
    const lastSelectedId = UserSettingsService.getProvisioningPageLastSelectedProvisioning();
    return provisionings.find((p) => p.id === lastSelectedId) ?? provisionings[0];
}
